import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface SelectCollaborationTypeProps {
  value: string;
  onChange: (value: string) => void;
}

const SelectCollaborationType = ({
  value,
  onChange
}: SelectCollaborationTypeProps) => (
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <InputLabel>Collaboration Type</InputLabel>
    <Select
      id="collaboration-type"
      name="collaboration-type"
      value={value}
      label="Collaboration Type"
      onChange={(event) => onChange(event.target.value)}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="collab">Collab</MenuItem>
      <MenuItem value="non-collab">Non-Collab</MenuItem>
    </Select>
  </FormControl>
);

export default SelectCollaborationType;
